import { render } from "./RicercaContatoriInversa.vue?vue&type=template&id=2ceba6c2"
import script from "./RicercaContatoriInversa.vue?vue&type=script&lang=js"
export * from "./RicercaContatoriInversa.vue?vue&type=script&lang=js"

import "./RicercaContatoriInversa.vue?vue&type=style&index=0&id=2ceba6c2&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__